import {
  getReckonAuthorizationCallbackURL,
  getReckonAuthorizeURL,
  getReckonRefreshURL,
  getReckonSpecificBookURL,
  getReckonSyncInvoiceURL
} from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";

const useReckonApi = () => {
  const ReckonAuthorize = async () => {
    const response = await privateAxios.post(getReckonAuthorizeURL, {
      code: null,
      state: null
    });
    return response;
  };

  const ReckonCallBack = async (bodyObj = {}) => {
    const response = await privateAxios.post(
      getReckonAuthorizationCallbackURL,
      bodyObj
    );
    return response;
  };

  const ReckonSelectSpecificBook = async (bodyObj = {}) => {
    const response = await privateAxios.post(getReckonSpecificBookURL, bodyObj);
    return response;
  };

  const ReckonRefresh = async () => {
    const response = await privateAxios.post(getReckonRefreshURL);
    return response;
  };

  const ReckonSyncInvoice = async () => {
    const response = await privateAxios.post(getReckonSyncInvoiceURL);
    return response;
  };

  return {
    ReckonAuthorize,
    ReckonCallBack,
    ReckonSelectSpecificBook,
    ReckonRefresh,
    ReckonSyncInvoice
  };
};

export default useReckonApi;
